import type { _RouteLocationBase } from 'vue-router'

const ModuleChangelogView = async () => import('@/views/other/ModuleChangelogView.vue')

/** @type {import('vue-router').RouteRecordRaw[]} */
export default [
  {
    meta: { title: 'Module-Changelog' },
    path: '/other/modules/changelog/:id',
    name: 'other--module-changelog',
    component: ModuleChangelogView,
    props: (route: _RouteLocationBase): { id: string } => {
      return { id: route.params.id.toString() }
    }
  }
]
